import React, { useEffect, useRef, useState } from 'react';

const CyberLoading = () => {
  const canvasRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    // Authentic Matrix characters mix (Katakana + Latin + Numbers)
    const chars = 'アァカサタナハマヤャラワガザダバパイィキシチニヒミリヰギジヂビピウゥクスツヌフムユュルグズブヅプエェケセテネヘメレゲゼデベペオォコソトノホモヨョロゴゾドボポヴッン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const fontSize = 16;
    const columns = canvas.width / fontSize;
    const drops = Array(Math.floor(columns)).fill(1);

    const draw = () => {
      ctx.fillStyle = 'rgba(2, 10, 13, 0.15)'; // Dark background fade
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#2ecc71'; // Sonar green
      ctx.font = fontSize + 'px monospace';
      
      for (let i = 0; i < drops.length; i++) {
        const text = chars[Math.floor(Math.random() * chars.length)];
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
    };
    
    const interval = setInterval(draw, 33);

    // Simulate progress while waiting for API
    const progInterval = setInterval(() => {
      setProgress(p => {
        // Slow down as it gets closer to 100 to simulate waiting
        const increment = Math.random() * (p > 80 ? 0.5 : 3);
        return p + increment > 99 ? 99 : p + increment;
      });
    }, 150);

    return () => {
      clearInterval(interval);
      clearInterval(progInterval);
      window.removeEventListener('resize', resize);
    };
  }, []);

  const totalBlocks = 24;
  const filledBlocks = Math.floor((progress / 100) * totalBlocks);

  return (
    <div className="relative w-full max-w-4xl min-h-[400px] aspect-[2/1] mx-auto bg-[#020a0d] overflow-hidden rounded-xl border border-sonar-green/20 shadow-[0_0_50px_rgba(46,204,113,0.15)] flex items-center justify-center">
      {/* Matrix Rain Canvas */}
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full opacity-60 pointer-events-none" />

      {/* Cyberpunk Loading Container */}
      <div className="relative z-10 w-[90%] max-w-[700px] bg-[#020a0d]/80 backdrop-blur-md p-1"
           style={{ clipPath: 'polygon(20px 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%, 0 20px)' }}>
        
        {/* Inner Bordered Box */}
        <div className="border-2 border-sonar-green shadow-[0_0_30px_rgba(46,204,113,0.3)_inset] p-8 lg:p-10 flex flex-col justify-center bg-[#06141b]/50"
             style={{ clipPath: 'polygon(18px 0, 100% 0, 100% calc(100% - 18px), calc(100% - 18px) 100%, 0 100%, 0 18px)' }}>
          
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-sonar-green font-black text-3xl md:text-4xl tracking-[0.3em] uppercase drop-shadow-[0_0_10px_#2ecc71] font-mono">
              LOADING...
            </h2>
            <div className="flex gap-3">
              <span className="text-sonar-green text-3xl md:text-4xl animate-pulse" style={{ animationDelay: '0ms' }}>»</span>
              <span className="text-sonar-green text-3xl md:text-4xl animate-pulse" style={{ animationDelay: '150ms' }}>»</span>
              <span className="text-sonar-green text-3xl md:text-4xl animate-pulse" style={{ animationDelay: '300ms' }}>»</span>
            </div>
          </div>

          <div className="flex gap-1.5 w-full h-10 md:h-12 p-1.5 border border-sonar-green/40 bg-sonar-green/5">
            {Array.from({ length: totalBlocks }).map((_, i) => (
              <div
                key={i}
                className={`flex-1 h-full transition-all duration-200 ${
                  i < filledBlocks 
                    ? 'bg-[#2ecc71] shadow-[0_0_15px_#2ecc71]' 
                    : 'bg-transparent'
                }`}
              />
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CyberLoading;